import { ModalKeys } from '../../components/EditSectionModals/types';
import { addressSection } from '../../components/sections/addressSection';
import { allergiesSection } from '../../components/sections/allergiesSection';
import { basicInfoSection } from '../../components/sections/basicInfoSection';
import { emergencyContactSection } from '../../components/sections/emergencyContactSection';
import { flightPreferencesSection } from '../../components/sections/flightPreferencesSection';
import { importantDatesSection } from '../../components/sections/importantDatesSection';
import { importantTravelDataSection } from '../../components/sections/importantTravelDataSection';
import { loyaltyProgramsSection } from '../../components/sections/loyaltyProgramsSection';
import { relatedAddressSection } from '../../components/sections/relatedAddressSection';
import { relatedAllergiesSection } from '../../components/sections/relatedAllergiesSection';
import { relatedBasicInfoSection } from '../../components/sections/relatedBasicInfoSection';
import { relatedComfortDetailsSection } from '../../components/sections/relatedComfortDetailsSection';
import { relatedContactInfoSection } from '../../components/sections/relatedContactInfoSection';
import { travelPreferencesByCategorySection } from '../../components/sections/travelPreferencesByCategorySection';

export const sectionRegistry = {
  [ModalKeys.basic_info]: basicInfoSection,
  [ModalKeys.related_basic_info]: relatedBasicInfoSection,
  [ModalKeys.primary_address]: addressSection,
  [ModalKeys.related_address]: relatedAddressSection,
  [ModalKeys.related_contact_info]: relatedContactInfoSection,
  [ModalKeys.emergency_contact]: emergencyContactSection,
  [ModalKeys.loyalty_programs]: loyaltyProgramsSection,
  [ModalKeys.important_dates]: importantDatesSection,
  [ModalKeys.important_travel_data]: importantTravelDataSection,
  [ModalKeys.allergies]: allergiesSection,
  [ModalKeys.related_allergies]: relatedAllergiesSection,
  [ModalKeys.related_comfort_details]: relatedComfortDetailsSection,
  [ModalKeys.flight_preferences]: flightPreferencesSection,
  [ModalKeys.travel_preferences_by_category]: travelPreferencesByCategorySection,
} as const;

export type SectionConfigFromRegistry = (typeof sectionRegistry)[keyof typeof sectionRegistry];
